<app-headnav [user]="userName" (info)="onInfo($event)" [logOutFlag]="logOutFlag" (getLogo)="onSavedLogo($event)">
</app-headnav>
<!--div class="task-box" cdkDrag>
  <div class="row" style="margin: 5px; background-color: #4C4C4C;">
    <span style="min-width: 10%; float: left; margin-top: 5px; margin-bottom: 5px;">
      <a style="cursor: pointer; color: #C2D63F;" (click)="expandcollapse();" title="Expand/Collapse">
        <i *ngIf="!expanded" class="fas fa-chevron-right" size="lg"></i>
        <i *ngIf="expanded" class="fas fa-chevron-down" size="lg"></i>
      </a>
    </span>

    <span *ngIf="!expanded" style="font-size: 22px; margin-left:10px; color: #C2D63F;"><strong>News
        Alert</strong></span>
    <span *ngIf="expanded" style="font-size: 22px; margin-left:32%; color: #C2D63F;"><strong>News
        Alert</strong></span>
  </div>
  <div *ngIf="expanded" class="row" style="margin: 1px; margin-top: 10px;">
    <iframe width="800px" height="800px" src="https://www.erisinfo.com/ca/">

    </iframe>
  </div>
</div-->

<div *ngIf="!userId" class="studio">
  <!--<div class="loading">
    <img src="assets/images/loader.gif" alt="spinner" width="64" height="64" />
    
  </div>-->
</div>
<div *ngIf="userId && userInfo.ERIS_STAFF=='Y'" class="studio">
  <section class="content">
		<div class="sidenav flex-container" [style.width]="sideNavWidth">
			<a href="#" title="Dashboard">
			<!--span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px"></span-->
			<span aria-hidden="true" data-icon="&#xe90a;" class="icon-dashboard" style="font-size:32px">
			</span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Dashboard</span>

			</a>
			<!-- <a href="report" title="Report Writer" target=_blank><i class="far fa-edit"></i></a><i class="fas fa-tachometer-alt"></i> -->
			<a href="cover" title="Cover Page" target=_blank><i class="icon-Cover" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Cover, Header & Footer</span>
			</a>
			<a href="template" title="Template" target=_blank><i class="icon-Template" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Templates</span>

			</a>
			<a href="complete" title="Completed Reports" target=_blank>
				<i style="margin-left: 5px" class="far fa-list-alt"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Complete Reports</span>
			</a>
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a href="company" style="border-top: 1px solid #000000;" title="Company" target=_blank><i class="icon-property" style="font-size:32px"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Company Info</span>

			</a>
					
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a title="Libraries" href="resources" style="border-top: 1px solid #000000" target=_blank>
			<span aria-hidden="true" data-icon="&#xe90f;" class="icon-Libraries" style="font-size:32px; margin-left:5px"></span>
			<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">Libraries</span>

			</a>
			<!--hr class="m-2" style="background:grey; z-index:9999999;"-->
			<a *ngIf="userInfo.ERIS_STAFF=='Y'" title="ERIS" href="erisonly" style="border-top: 1px solid #000000" target=_blank class="active">
				<i  class="icon-eris" style="font-size: 32px;"></i>
				<span *ngIf="toggleSideBarVar" style="position: absolute; left: 86px">ERIS Only</span>

				</a>

			<a  (click)="toggleSideBar()"> 

				<i *ngIf="!toggleSideBarVar" class="pi pi-chevron-right" style="font-size: 24px;"></i>
				<i  *ngIf="toggleSideBarVar"class="pi pi-chevron-left" style="font-size: 24px;"></i>

			</a>





			
		</div>
    <div id="myTab" class="tableView">
      <div style="padding:20px">
        <div class="row">
          <div class="col-md-6" style=" color: white; ">
           <div class="row"> <div style="text-align:center; font-weight:600" class="offset-md-4 col-md-4">Company Information</div>
           <div  class="col-md-4"> 
            <a href="javascript:void(0)" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 m-2 ml-4"
            style="background:#c1d43f; color:black; float:right"
           (click)="resetAll()">
           <span> Onboard new Company</span>
               
         </a>
           </div>

          </div>
            <label style="margin-left:-15px" class="col-md-6" data-error="wrong" data-success="right"
            for="defaultForm-email">Company Name:</label>
            <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyName"
            placeholder="Company Name" [ngModelOptions]="{standalone: true}">

          <label style="margin-left:-15px" class="col-md-6" data-error="wrong" data-success="right"
            for="defaultForm-email">Location Address:</label>
 
          <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="locationName"
            placeholder="Location Name" [ngModelOptions]="{standalone: true}">
          <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyAddress1"
            placeholder="Address1" [ngModelOptions]="{standalone: true}">
          <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyAddress2"
            placeholder="Address2" [ngModelOptions]="{standalone: true}">
            <div class="row">
            <div class="col-md-2">
              <input class="form-control validate rptInfo" [(ngModel)]="companyCity" placeholder="City"
              [ngModelOptions]="{standalone: true}">
            </div>
            <div class="offset-md-1 col-md-3">
              <input class="form-control  validate rptInfo " [(ngModel)]="companyState"
              placeholder="State/Province" [ngModelOptions]="{standalone: true}">
            </div>

            <div class="offset-md-1 col-md-2">
              <input class="form-control  validate rptInfo " [(ngModel)]="companyZip"
            placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
            </div>

            <div class="offset-md-1 col-md-2">
              <input class="form-control validate rptInfo " [(ngModel)]="companyCount"
              placeholder="Country" [ngModelOptions]="{standalone: true}">
            </div>
            
            </div>
      <br>
      <div class=row>
        <div class=col-md-6>
          <label  data-error="wrong" data-success="right"
          for="defaultForm-email">ERIS Branch ID:</label>
          <br>
        <input class="form-control validate rptInfo" [(ngModel)]="companyERIS"
          [ngModelOptions]="{standalone: true}">
         </div>
      </div>

      <div>
            <br>
            <!--<button (click)="toMessage()" id="Edit banner message" class="btn btn-sm mt-1 mr-2 ml-3 float-right"
              style="background:#c1d43f; color:black;font-size:17px; padding:4px">
              Manage Message</button>-->
            <button [disabled]="!showSearch" (click)="branchDisappear()" id="Go to Added Branch" class="btn btn-sm mt-1 mr-2 ml-3 float-right"
              style="background:#c1d43f; color:black;font-size:17px; padding:4px">
            Show Added Branches</button>
            <button (click)="addCompany();" class="btn btn-sm mt-1 mr-2 ml-3 float-right"
            style="background:#c1d43f; color:black;font-size:17px">
            Add Company</button>
      </div>

          <br>
          <br>
      <!--
      <div id="successMessage" class="mt-1 mr-2 ml-3 float-right" style="visibility: hidden;">
        {{success? 'Company Added': 'Please enter Company Name and Address'}}
      </div>
      -->
      
          <br>
          <br>
          
            <span class="mt-3"> 
              <br>
              <div class="row"> 
                
                <div style="text-align:center;font-weight:600" class="offset-md-4 col-md-4">Company Administrator</div></div>
              <form [formGroup]="userform">
                <div class="md-form mb-1">
            
                  <label data-error="wrong" data-success="right" for="defaultForm-email">First Name:</label>
                  <input class="form-control validate rptInfo" [(ngModel)]="firstname"
                    [ngModelOptions]="{standalone: true}">
                </div>
        
                <div class="md-form mb-1">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Last Name:</label>
                  <input class="form-control validate rptInfo" [(ngModel)]="lastname"
                    [ngModelOptions]="{standalone: true}">
        
                </div>
                <div class="md-form mb-1">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Job Title:</label>
                  <input class="form-control validate rptInfo" [(ngModel)]="jobTitle"
                    [ngModelOptions]="{standalone: true}">
        
                </div>
                <div class="md-form mb-1">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Phone (Number Only):<span
                      style="color:red"
                      *ngIf="!userform.controls.userPhone.pristine && !userform.controls.userPhone.valid ">
                      *</span></label>
                  <input mask="(000) 000-0000"  placeholder="Number Only"
                    [class.invalid]="!userform.controls.userPhone.pristine && !userform.controls.userPhone.valid"
                    formControlName="userPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner">
                </div>
                <div class="md-form mb-1">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Email: <span style="color:red"
                      *ngIf="(!userform.controls.userEmail.pristine && !userform.controls.userEmail.valid) || userform.value.userEmail=='' || !userform.value.userEmail">
                      *</span></label>
                  <input [class.invalid]="(!userform.controls.userEmail.pristine && !userform.controls.userEmail.valid)"
                    formControlName="userEmail" id="defaultForm-pass" class="form-control validate rptInfo"
                    (change)="show(form.value.userEmail)">
        
                </div>
        
                <div class="md-form mb-1">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Alternate Email: <span
                      style="color:red"
                      *ngIf="!userform.controls.alternate.pristine && !userform.controls.alternate.valid">
                      *</span></label>
                  <input [class.invalid]="!userform.controls.alternate.pristine && !userform.controls.alternate.valid"
                    formControlName="alternate" id="defaultForm-pass" class="form-control validate rptInfo"
                    (change)="show(form.value.alternate)">
        
                </div>
                <div class="md-form mb-1">
                  <label data-error="wrong" data-success="right" for="defaultForm-pass">Role:</label>
                  <select disabled style="width:100%" class="rptInfo" [(ngModel)]="role"
                  [ngModelOptions]="{standalone: true}" >
                    <option [value]="type.ROLE_ID" *ngFor="let type of roles">
                      {{type.ROLE_NAME}} </option>
        
                  </select>
                  <!--<input style="width:100%" class="rptInfo"  disabled placeholder="System Manager">
                    
                  -->
                  
  
  
                </div>
                <button (click)="inviteUser();" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mt-1 float-right"
              style="background:#c1d43f; color:black;font-size:17px" [disabled]="!userform.valid && addedCompany">Invite
                  User</button>
          
        
              </form>
            </span>
          </div>
          <div class="col-md-6">
            <p-table *ngIf="!showSearch" #tt styleClass="p-datatable-sm" [value]="addedBranches" [columns]="branchesCols" [scrollable]="true"
            scrollHeight="calc(100vh - 250px)">
            <ng-template pTemplate="caption">

              <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
                <span>
                  
                 Branches
                 <a href="javascript:void(0)" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4"
                 style="background:#c1d43f; color:black; padding:4px"
                (click)="showSearch=true; branchAppear(); addAppear()">
                 <span > Go Back</span>
               </a>
                  <!-- <a class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4" style="background:#58a400; color:white"
                    data-toggle="modal" data-target="#reportsModal2" (click)="newSlot=true;"> Add New Repeat Field</a> -->
                </span>
                <span>

                <input type="search" pInputText placeholder="Search"
                  (input)="tt.filterGlobal($event.target.value, 'contains')">
                </span>
              </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>

              <tr style="font-size:12px">
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="padding:1px; font-size:11px" [pSortableColumn]="col.field">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>

              </tr>
              <tr> 
                <th *ngFor="let col of columns; let i=index" style="padding:2px">
                  <input *ngIf="col.field!='CATEGORY_NAME' && col.field!='SUBCATEGORY_NAME'" class="inputHeader" pInputText type="text"
                    (input)="tt.filter($event.target.value, col.field, col.filterMatchMode)"
                    style="margin:0 2px; font-size:12px; width:98%;">
                    
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
              <tr style="font-size:12px">
                <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                  <span *ngIf="col.field=='HF_TITLE'">
                    <a target="_blank"[href]="'/cover/Footer-' +user.HEADERFOOTER_ID" style="color:rgb(195,212,47)"> {{user[col.field]}}</a>
                    <a target="_blank"[href]="user.HF_URL" style="color:rgb(195,212,47); float:right"> <i class="erisGreen fas fa-search"></i></a>

                  </span>
                  <span class="line-clamp1" *ngIf="col.field!='HF_TITLE' && col.field!='TEMPLATE_TITLE'&&col.field!='DATE_UPDATED'" style="float:left">{{user[col.field]}} </span>
                  
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-treeTable  [style]="{'background':'#323232'}" [scrollable]="true" *ngIf="showSearch"
          scrollHeight="calc(100vh - 200px)" [virtualScroll]="true" [value]="searchResults">
            <ng-template pTemplate="caption"  >
              <div style="background:#323232; margin-bottom:-5px; margin-right:-15px; margin-top:-15px; margin-left:-15px; font-weight:500" class="p-4">

       
              
              <span >
              Search ERIS Clients: <input type="text" class="rptInfo" [(ngModel)]="searchField" (change)="searchEris()">
  
          </span> 
          <br>
          Results: {{searchResults?.length}} 
        </div>
        </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData"  >
              <div  style="border-radius: 10px; background:#464646; width:98%"  *ngIf="rowData.project" (click)="handleClick($event, rowNode, rowData)" class="p-col-12 changebackground m-2"  >
                <div class="product-list-item">
                   
                    <div class="product-list-detail">
                      <p-treeTableToggler style="color:white; float:right" [rowNode]="rowNode"></p-treeTableToggler>  {{rowData.COMPANY_NAME}} 
                      <span style="float:right">
       
                      <!-- <a *ngIf="rowNode.node.children.length>0" id="deselectAllButton" href="javascript:void(0)" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 mr-1 mt-1 float-right"
                        style="background:#c1d43f; color:black; font-size:17px" (click)="deselectAll(rowNode)">

                        Deselect All Branches
                      </a> -->
                      </span>
                    </div>
                    <!-- <div class="product-list-action">
              
                      <p-button  label="Select"></p-button>
                  </div>
                   -->
                </div>

            </div>
                <div *ngIf="rowData.project && 	rowNode.node.expanded ">
                  <button href="javascript:void(0)" *ngIf="true" id = 'Selected Branch Button' class="btn btn-sm pl-2 pr-2 pt-1 pb-1 ml-2 mr-2 float-right"
                    style="background:#c1d43f; color:black;font-size:13px; padding:4px;"  (click)="addAllBranches(rowData); addAppear()"
                    [disabled]="branchEnable">

                  Add Selected Branches
                </button>
                  <a (click)="handle2($event, rowNode, rowData);" *ngIf="rowNode.node.children.length>0" id="selectAllButton" href="javascript:void(0)" class="btn btn-sm pl-2 pr-2 pt-1 pb-1 ml-2 mr-2 float-right"
                    style="background:#c1d43f; color:black;font-size:13px" >
                      <!-- <span
                        style="font-weight:bold; color:rgb(195,212,47)">P</span> -->
                      {{select? 'Select': 'Deselect'}} All
                  </a>
                  
                </div>
                <div *ngIf="!rowData.project" class="p-col-12 changebackground m-2"  [class.changebackground2]="rowData.specialSelected"
                (click)="addLocation($event, rowData, rowNode); enableBranch(rowNode)">
         
                  <div class="product-list-item ">
                    <input 
                    id="checkbox" type="checkbox" [checked]="rowData.selected">
                      <div class="product-list-detail ml-5" style="color: white;">
                        {{rowData.ADDRESS}},
                        {{rowData.CITY}},
                        {{rowData.PROVSTATE}}
                        <a  id="selectOffice" title="Select as Head Office" style="cursor:pointer; color: #58a400; float: right;" class="ml-1">

                          <i  id="selectOffice" [class.erisGreen]="rowData.specialSelected" class="fas fa-building" (click)='fillLocation()'></i>
                        </a>
                      </div>
                      <!-- <div class="product-list-action">
                
                        <p-button  label="Select"></p-button>
                    </div>
                     -->
                  </div>
              </div>
                  <div>
             
                  </div>
            </ng-template>
        </p-treeTable>

        <p-dataView *ngIf="false"[paginatorDropdownScrollHeight]="'100px'"  [paginator]="true" [rows]="10"[value]="locations" layout="list">
          <ng-template pTemplate="header">
       
        Locations: {{searchResults.length}} 
        <a href="javascript:void(0)" class="btn btn-sm pt-0 pb-0 pl-1 pr-1 ml-4"
									style="background:#c1d43f; color:black" data-target="#reportsModal" (click)="locations=[];">
									<!-- <span
										style="font-weight:bold; color:rgb(195,212,47)">P</span> -->
									<span> Go Back</span>
								</a>
      </ng-template>
          <ng-template let-car pTemplate="listItem">
            <div (click)="selectedLocation=car; fillLocation()" class="p-col-12 changebackground m-2" >
              <div class="product-list-item">
        
                  <div class="product-list-detail">
                    {{car.ADDRESS}}
                    {{car.CITY}}
                    
                    
                  </div>
                  <!-- <div class="product-list-action">
            
                    <p-button  label="Select"></p-button>
                </div>
                 -->
              </div>
          </div>
              <div>
         
              </div>
          </ng-template>
      </p-dataView>
      </div>
        </div>
      </div>

  
    <!-- <p-table #pt2 styleClass="p-datatable-sm" [value]="searchResults" [columns]="erisCols" [scrollable]="true"
    scrollHeight="calc(100vh - 200px)">
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
        <span>
            Search Companies: <input type="text" [(ngModel)]="searchField" (change)="searchEris()">
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>

      <tr style="font-size:12px">
        <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-user let-i="rowIndex" let-columns="columns">
      <tr style="font-size:12px;">
        <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
          <span class="line-clamp1"
            >{{user[col.field]}}
          </span>

        </td>
      </tr>
    </ng-template>
  </p-table> -->

</div>
<div class="modal fade" id="reportsModal2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
aria-hidden="true">
<div class="modal-dialog" role="document">
  <div class="modal-content" style="background:#D8D8D8">
    <div class="modal-header text-center">
      <h4 *ngIf="newUser" class="modal-title w-100 font-weight-bold">Add New User</h4>
      <h4 *ngIf="!newUser" class="modal-title w-100 font-weight-bold">Edit User</h4>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body mx-2">
      <form [formGroup]="userform">
        <div class="md-form mb-1">
          <div style="float:right">
            <label data-error="wrong" data-success="right" for="defaultForm-pass">External:</label>
            <label style="margin-left:10px" class="switch">
              <input type="checkbox" [(ngModel)]="userExternal" [ngModelOptions]="{standalone: true}">
              <span class="slider round"></span>
            </label>
          </div>
          <label data-error="wrong" data-success="right" for="defaultForm-email">First Name:</label>
          <input class="form-control validate rptInfo" [(ngModel)]="firstname"
            [ngModelOptions]="{standalone: true}">
        </div>

        <div class="md-form mb-1">
          <label data-error="wrong" data-success="right" for="defaultForm-pass">Last Name:</label>
          <input class="form-control validate rptInfo" [(ngModel)]="lastname"
            [ngModelOptions]="{standalone: true}">

        </div>
        <div class="md-form mb-1">
          <label data-error="wrong" data-success="right" for="defaultForm-pass">Job Title:</label>
          <input class="form-control validate rptInfo" [(ngModel)]="jobTitle"
            [ngModelOptions]="{standalone: true}">

        </div>
        <div class="md-form mb-1">
          <label data-error="wrong" data-success="right" for="defaultForm-pass">Phone (Number Only):<span
              style="color:red"
              *ngIf="!userform.controls.userPhone.pristine && !userform.controls.userPhone.valid ">
              *</span></label>
          <input mask="(000) 000-0000"  placeholder="Number Only"
            [class.invalid]="!userform.controls.userPhone.pristine && !userform.controls.userPhone.valid"
            formControlName="userPhone" id="defaultForm-pass" class="form-control validate rptInfo no-spinner">
        </div>
        <div class="md-form mb-1">
          <label data-error="wrong" data-success="right" for="defaultForm-pass">Email: <span style="color:red"
              *ngIf="(!userform.controls.userEmail.pristine && !userform.controls.userEmail.valid) || userform.value.userEmail=='' || !userform.value.userEmail">
              *</span></label>
          <input [class.invalid]="(!userform.controls.userEmail.pristine && !userform.controls.userEmail.valid)"
            formControlName="userEmail" id="defaultForm-pass" class="form-control validate rptInfo"
            (change)="show(form.value.userEmail)">

        </div>

        <div class="md-form mb-1">
          <label data-error="wrong" data-success="right" for="defaultForm-pass">Alternate Email: <span
              style="color:red"
              *ngIf="!userform.controls.alternate.pristine && !userform.controls.alternate.valid">
              *</span></label>
          <input [class.invalid]="!userform.controls.alternate.pristine && !userform.controls.alternate.valid"
            formControlName="alternate" id="defaultForm-pass" class="form-control validate rptInfo"
            (change)="show(form.value.alternate)">

        </div>
        <div class="md-form mb-1 rptInfo">
          <label data-error="wrong" data-success="right" for="defaultForm-pass">Role:</label>
          <input class="form-control validate">

        </div>
  

      </form>
    </div>
    <div *ngIf="newUser" class="modal-footer d-flex justify-content-center">
      <!-- <button (click)="addUser();" class="btn btn-default btn-outline-dark" [disabled]="!userform.valid">Add
        User</button> -->
      <button (click)="inviteUser();" class="btn btn-default btn-outline-dark" [disabled]="!userform.valid">Invite
        User</button>
    </div>

  </div>
</div>
</div>

<div class="modal fade" id="companyModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
aria-hidden="true">
<div class="modal-dialog" role="document">
  <div class="modal-content" style="background:#D8D8D8">
    <div class="modal-header text-center">
      <h4  class="modal-title w-100 font-weight-bold">Add New Company</h4>
    
        <span aria-hidden="true">&times;</span>
     
    </div>
    <div class="modal-body mx-3">
      <form [formGroup]="form">

        <div class="md-form mb-3">
          <!-- <div class="container">
            <div class="row">
              <label style="margin-left:-15px" class="col-md-6" data-error="wrong" data-success="right"
                for="defaultForm-email">Location Address:</label>
              <div class="col-md-6 text-right">
                <label data-error="wrong" data-success="right" for="defaultForm-pass">Head Office:</label>
                <label style="margin-left:10px" class="switch">
                  <input type="checkbox" [(ngModel)]="headOffice" [ngModelOptions]="{standalone: true}">
                  <span class="slider round"></span>
                </label>
              </div>
              <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="locationName"
                placeholder="Location Name" [ngModelOptions]="{standalone: true}">
              <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyAddress1"
                placeholder="Address1" [ngModelOptions]="{standalone: true}">
              <input class="form-control validate rptInfo col-md-12 mb-3" [(ngModel)]="companyAddress2"
                placeholder="Address2" [ngModelOptions]="{standalone: true}">
              <input class="form-control validate rptInfo col-md-2" [(ngModel)]="companyCity" placeholder="City"
                [ngModelOptions]="{standalone: true}">
              <input class="form-control validate rptInfo offset-md-1 col-md-3" [(ngModel)]="companyState"
                placeholder="State/Province" [ngModelOptions]="{standalone: true}">
              <input class="form-control validate rptInfo offset-md-1 col-md-2" [(ngModel)]="companyZip"
                placeholder="Zip/Postal" [ngModelOptions]="{standalone: true}">
              <input class="form-control validate rptInfo offset-md-1 col-md-2 mb-3" [(ngModel)]="companyCount"
                placeholder="County" [ngModelOptions]="{standalone: true}">

              <label style="margin-left:-15px" class="col-md-12" data-error="wrong" data-success="right"
                for="defaultForm-email">ERIS Branch ID:</label>
              <input class="form-control validate rptInfo col-md-12" [(ngModel)]="companyERIS"
                [ngModelOptions]="{standalone: true}">
            </div>
          </div> -->
        </div>
        <!-- <div class="md-form mb-3">
      </div>
      <div class="md-form mb-3">
        <input class="form-control validate rptInfo" [(ngModel)]="companyAddress"
          [ngModelOptions]="{standalone: true}">
      </div>
      <div class="md-form mb-3">
        <input class="form-control validate rptInfo" [(ngModel)]="companyAddress"
          [ngModelOptions]="{standalone: true}">
      </div>
      <div class="md-form mb-3">
        <input class="form-control validate rptInfo" [(ngModel)]="companyAddress"
          [ngModelOptions]="{standalone: true}">
      </div> -->
      </form>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button (click)="addCompany()" class="btn btn-default btn-outline-dark">Add
        Company</button>
    
    </div>

  </div>
</div>
</div>
  </section>
  <app-panel [header]="'Profile Management'" [opened]="showLogo" [align]="'right'" [fixed]="[-10, 54]"
    (didClosed)="showLogo = null">

    <ng-container name="body">

      <app-logo *ngIf="userInfo" class="w-100 h-100" [logoInfo]="logoInfo" [userInfo]='userInfo'
        (editReport)="onEditReport($event)" (logOut)='logOut()'></app-logo>
    </ng-container>
  </app-panel>
</div>